import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { GeoMultiMethodUpdateRequestPayload } from '@/models/ps-management/multi-methods.model';

export default class UpdateGeoMultiMethodRequest extends ApiResourceMethod<{}> {
  public perform(data: GeoMultiMethodUpdateRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${data.multiMethodId}`,
        data,
      },
      (response: BaseResponse<{}>) => {
        return response.data;
      },
    );
  }
}
